module.exports = __webpack_public_path__ + "img/轮播5.a9475c5e.png";